module.exports = __webpack_public_path__ + "static/radiclewebsitegif-2-b7749136feb40948f43323c191606c78.mp4";